import { IItem } from "./PopOverMenu";
import "./style/PopOverMenuItem.scss";

export const PopOverMenuItem = ({ icon, title, onClick }: IItem) => {
  return (
    <button className="PopOverMenuItem" onClick={onClick}>
      <div className="PopOverMenuItem-Img">
        <img src={icon} alt={title} />
      </div>
      <span className="PopOverMenuItem-Title">{title}</span>
    </button>
  );
};
